import { AppHelper } from "../appHelper.js"
import { CommonApp, CommonAppProps } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class EditMachine extends React.Component<CommonAppProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }


    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass>("ProjectMachine/SaveMachine", this.props.entity)
                .then(result => {
                if (result.Code === 0) {
                    let indivData = result.Data.IndividualFields;
                    Helper.updateEntity(this.props.entity, result.Data);
                    for (var key in indivData) {
                        this.props.entity.IndividualFields[key] = indivData[key];
                    }
                    this.props.entity.IsNew = false;
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                this.common.handlePostSave(result.Code === 0, closeAfterSave);
            });
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}
